import type { ScreenBase } from "@frui.ts/screens/dist";
import { Router } from "@frui.ts/screens/dist";
import { Modules } from "config";
import { computed } from "mobx";
import PermissionAreaRepository from "repositories/permissionAreaRepository";
import LocalizationService from "services/localizationService";
import EventBus from "services/eventBus";
import ConfirmationService from "services/confirmationService";
import NotificationService from "services/notificationService";
import ListViewModel from "viewModels/listViewModel";
import SecurityService from "services/securityService";
import FaultyCombinationDetailViewModel from "./faultyCombinationDetailViewModel";
import type PermissionAreaWithFaultyCombinationsResponse from "entities/permissionAreaWithFaultyCombinationsResponse";
import OptionsService from "services/optionsService";
import PermissionArea from "entities/permissionArea";
import FaultyCombinationsFilter from "entities/filters/faultyCombinationsFilter";

const navigationName = "faulty-combinations";

@Router.registerRoute({ route: navigationName, name: Router.Self, children: [FaultyCombinationDetailViewModel] })
export default class FaultyCombinationsViewModel extends ListViewModel<
  PermissionAreaWithFaultyCombinationsResponse,
  FaultyCombinationDetailViewModel,
  ScreenBase,
  FaultyCombinationsFilter
> {
  readonly modelName = "permissionArea";

  @computed
  get areaOptions() {
    return this.optionsService.entityOptions(PermissionArea);
  }

  constructor(
    protected detailViewModelFactory: ReturnType<typeof FaultyCombinationDetailViewModel.Factory>,
    protected repository: PermissionAreaRepository,
    protected localizationService: LocalizationService,
    protected eventBus: EventBus,
    protected confirmationService: ConfirmationService,
    protected notificationService: NotificationService,
    protected securityService: SecurityService,
    private optionsService: OptionsService
  ) {
    super();
    this.navigationName = navigationName;
  }

  protected async fetchData() {
    return this.repository.getAllFaultyCombinations(this.filter.areaId);
  }

  @computed
  get allowDelete() {
    return false;
  }

  protected createFilter(): FaultyCombinationsFilter {
    return new FaultyCombinationsFilter();
  }

  translate(code: string, size?: number) {
    return this.localizationService.translateModule(Modules.users, `faultyCombinations.${code}`, size);
  }

  translateArea(areaId: string) {
    return this.optionsService.entityOptions(PermissionArea).find(item => item.id === areaId)?.label ?? "";
  }
}
